module.exports = __webpack_public_path__ + "static/media/vh.ec000a6b.png";